import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";
import CustomText from "../../../common/general/CustomText/CustomText";
import { colors, spacing } from "../../../../styles/design-system";

import { StyleSheet, View } from "react-native";

interface Value {
  skillsToImprove: string[];
  learningStyles: string[];
}

interface Props {
  value: Value;
  onChange: (v: Value) => void;
}

export default function LearningPreferencesEditor({ value, onChange }: Props) {
  const { t } = useTranslation();
  const skillOptions: ChipOption[] = useMemo(
    () => [
      { key: "problem_solving", value: t("text.companion_onboarding_skill_problem_solving") },
      { key: "exam_prep", value: t("text.companion_onboarding_skill_exam_prep") },
      { key: "writing", value: t("text.companion_onboarding_skill_writing") },
      { key: "coding", value: t("text.companion_onboarding_skill_coding") },
      { key: "memorization", value: t("text.companion_onboarding_skill_memorization") },
      { key: "time_management", value: t("text.companion_onboarding_skill_time_management") },
    ],
    [t]
  );
  const learningMethodOptions: ChipOption[] = useMemo(
    () => [
      { key: "practice_problems", value: t("text.companion_onboarding_method_practice") },
      { key: "step_by_step", value: t("text.companion_onboarding_method_step_by_step") },
      { key: "visual_examples", value: t("text.companion_onboarding_method_visual") },
      { key: "quick_summaries", value: t("text.companion_onboarding_method_summaries") },
      { key: "reading", value: t("text.companion_onboarding_method_reading") },
      { key: "hands_on", value: t("text.companion_onboarding_method_hands_on") },
    ],
    [t]
  );

  return (
    <View style={styles.container}>
      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        text="companion_onboarding_step4_skills_label"
        size="xs"
        weight="bold"
      />
      <ChipSelector
        options={skillOptions}
        selectedKeys={value?.skillsToImprove ?? []}
        onSelectionChange={(v) => onChange({ ...value, skillsToImprove: v })}
        multiSelect
      />

      <CustomText
        style={{ color: colors.grey[500], marginBottom: spacing.xxs }}
        text="companion_onboarding_step4_methods_label"
        size="xs"
        weight="bold"
      />

      <ChipSelector
        options={learningMethodOptions}
        selectedKeys={value?.learningStyles ?? []}
        onSelectionChange={(v) => onChange({ ...value, learningStyles: v })}
        multiSelect
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: spacing.md,
  },
});
